import { createContext, useCallback, useContext, useMemo, useState } from 'react'

const IntegrationsModalContext = createContext(null)

export function IntegrationsModalProvider({ children }) {
  const [open, setOpen] = useState(false)

  const openIntegrations = useCallback(() => {
    setOpen(true)
  }, [])

  const closeIntegrations = useCallback(() => {
    setOpen(false)
  }, [])

  const value = useMemo(
    () => ({ open, openIntegrations, closeIntegrations }),
    [open, openIntegrations, closeIntegrations],
  )

  return <IntegrationsModalContext.Provider value={value}>{children}</IntegrationsModalContext.Provider>
}

export function useIntegrationsModal() {
  const ctx = useContext(IntegrationsModalContext)
  if (!ctx) {
    throw new Error('useIntegrationsModal must be used within IntegrationsModalProvider')
  }
  return ctx
}

export function useIntegrationsModalOptional() {
  return useContext(IntegrationsModalContext)
}
